@if (currentStep() === 'password') {
    <p class="suif-body-copy">To continue, please verify your identity by entering your current password.</p>

    @if (errors.validationError) {
        <app-message-box level="error" [messages]="['Authentication failed. Please try again.']"></app-message-box>
    }

    <form [formGroup]="passwordForm" (ngSubmit)="onContinue()">
        <app-input
            formControlName="currentPassword"
            fieldId="reauth-current-password"
            label="Current Password"
            type="password"
            isRequired
            autoFocus>
        </app-input>

        <div class="button-row">
            <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            <app-wait-button
                buttonType="submit"
                [waiting]="isVerifying()"
                label="Continue">
            </app-wait-button>
        </div>
    </form>
}

@if (currentStep() === 'mfa-challenge') {
    <p class="suif-body-copy">{{ mfaChallengeInfoByMethod[mfaChallengeMethod] }}</p>

    @if (errors.validationError) {
        <app-message-box level="error" [messages]="['Verification failed. Please try again.']"></app-message-box>
    }

    <form [formGroup]="mfaChallengeForm" (ngSubmit)="onSubmitMfaChallenge()">
        <app-input
            formControlName="verificationCode"
            fieldId="reauth-verification-code"
            label="Verification Code"
            [inputMask]="'000000'"
            inputmode="numeric"
            isRequired
            autoFocus>
        </app-input>

        <div class="button-row">
            <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            <app-wait-button
                buttonType="submit"
                [waiting]="isVerifying()"
                label="Continue">
            </app-wait-button>
        </div>
    </form>
}
